import axios from 'axios';
import router from '@/router'
import qs from "qs";
import { vapidKey } from '@/components/_service/Config.js';
import * as localforage from "localforage";
//import ServiceWorkerStorage from 'serviceworker-storage';
//const storage = new ServiceWorkerStorage('sw:storage', 1);

//const vapidPublicKey = vapidKey;

export const notificationservice = {
	createSubscription,
	subscribe,
	getSubscription,
	findSubscription1,
	showNotification

 };


function createSubscription(serviceWorkerRegistation) {
            //console.log('ask for active service worker registration');
          //  console.log(serviceWorkerRegistation )
            if (serviceWorkerRegistation === null) {
                //console.log( navigator.serviceWorker)
                return navigator.serviceWorker.ready // returns a Promise, the active SW registration
                .then(swreg => {
                  // console.log("createSubscription:" + swreg)
                  //  console.log(swreg)
                    serviceWorkerRegistation = swreg

                    return subscribe(serviceWorkerRegistation)
                })
            } else {
               // fstCheck= true
                return subscribe(serviceWorkerRegistation)
            }
}

function subscribe(swreg) {
          //  console.log('create new subscription for this browser on this device');
            // create new subscription for this browser on this device
	const vapidPublicKey = vapidKey
//	console.log(vapidPublicKey)
	const convertedVapidPublicKey = urlBase64ToUint8Array(vapidPublicKey)
	// // return the subscription promise, we chain another then where we can send it to the server
	return swreg.pushManager.subscribe({
	    userVisibleOnly: true,
	    // This is for security. On the backend, we need to do something with the VAPID_PRIVATE_KEY
	    // that you can find in .env to make this work in the end
	    applicationServerKey: convertedVapidPublicKey
	})
  }

function getSubscription(swreg) {
          //  console.log('[getSubscription] ask for available subscription');
   return swreg.pushManager.getSubscription()
}

function findSubscription1() {
          //  console.log('[findSubscription] get active service worker registration');
   if ('serviceWorker' in navigator) {
      return navigator.serviceWorker.ready
      .then(registration => {
        //  console.log('[findSubscription] active subscription op');
       //   this.serviceWorkerRegistation = swreg
        //  console.log(registration)

          return registration.pushManager.getSubscription();
      })
   }

}
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function showNotification() {
    if ('serviceWorker' in navigator) {
       if (Notification.permission === 'granted') {
          navigator.serviceWorker.ready // returns a Promise, the active SW registration
            .then(swreg => swreg.showNotification('Notifications granted', {
                body: 'You will recieve notification',
                icon: '/img/icons/pwa-192.png',
                badge: '/img/icons/pwa-72.png',
                vibrate: [300, 200, 300],
               // vibrate: [500,110,500,110,450,110,200,110,170,40,450,110,200,110,170,40,500],
               // dir:  'ltr' ,
                data: {
                  url:'https://m.advenueplatform.com'
                },

            }))
      }
    }
}
